<div class="cabecalho-qrcode  d-none d-md-block" id="qrcodeDecisaoCerta">
  <qrcode [qrdata]="qrcodeUrl" [width]="76"></qrcode>
</div>
<div class="cabecalho-qrcode d-md-none" id="qrcodeDecisaoCerta">
  <qrcode [qrdata]="qrcodeUrl" [width]="56"></qrcode>
</div>
